import { Acc } from '../../../../components/edit-object/design/Accordion';
import { Field } from '../../../../components/edit-object/design/Field';
import { Textarea } from '../../../../components/edit-object/design/Form';
import type { ArtworkDetailsForm } from '../useArtworkDetailsForm';

interface Props {
  form: ArtworkDetailsForm;
}

const SUMMARY_MAX = 140;
const truncate = (s: string, max: number) =>
  s.length <= max ? s : `${s.slice(0, max).trimEnd()}…`;

export const MediaDescriptionSection = ({ form }: Props) => {
  const { mediaDescription, setMediaDescription } = form;
  const summary = truncate(mediaDescription || '', SUMMARY_MAX);

  return (
    <Acc
      id="sec-media"
      title="Media"
      summary={summary}
      emptyPlaceholder="No media description"
      defaultExpanded
    >
      <Field label="Media description">
        <Textarea
          id="media-description"
          rows={3}
          value={mediaDescription}
          onChange={(e) => setMediaDescription(e.target.value)}
          placeholder="Describe the materials and technique…"
        />
      </Field>
    </Acc>
  );
};
